import type { GameModeId } from '@/gameplay/types'

const KEY = 'miner:records:v1'

export interface RecordEntry {
  bestMs: number
  clearedAt: string
  seed?: number
}

export type RecordsStore = Record<string, Partial<Record<GameModeId, RecordEntry>>>

export function loadRecords(): RecordsStore {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as RecordsStore
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export function getBest(mapId: string, mode: GameModeId): RecordEntry | null {
  return loadRecords()[mapId]?.[mode] ?? null
}

/** Запись только при победе. Возвращает true, если новый рекорд. */
export function saveWin(
  mapId: string,
  mode: GameModeId,
  timeMs: number,
  seed?: number,
): { isNewRecord: boolean; previousBestMs: number | null } {
  const store = loadRecords()
  const prev = store[mapId]?.[mode] ?? null
  const previousBestMs = prev?.bestMs ?? null
  const isNewRecord = previousBestMs === null || timeMs < previousBestMs

  if (isNewRecord) {
    if (!store[mapId]) store[mapId] = {}
    store[mapId]![mode] = {
      bestMs: timeMs,
      clearedAt: new Date().toISOString(),
      seed,
    }
    localStorage.setItem(KEY, JSON.stringify(store))
  }

  return { isNewRecord, previousBestMs }
}

export function clearAllRecords(): void {
  localStorage.removeItem(KEY)
}

export function formatTime(ms: number): string {
  const totalSec = Math.floor(ms / 1000)
  const m = Math.floor(totalSec / 60)
  const s = totalSec % 60
  const d = Math.floor((ms % 1000) / 100)
  return `${m}:${String(s).padStart(2, '0')}.${d}`
}
